import { buildContentVideoUrl } from '../../../config';

export function coverUrlForTrack(track) {
  return buildContentVideoUrl({
    filename: track?.cover_image,
  });
}

export function videoUrlForTrack(track) {
  return buildContentVideoUrl({
    filename: track?.video,
  });
}

/** Pick a frame past a black or title intro, without running past the end. */
export function coverFrameTime(duration) {
  if (!Number.isFinite(duration) || duration <= 0) return 0;
  if (duration < 0.8) return duration * 0.5;
  return Math.min(1.25, Math.max(0.45, duration * 0.12), duration - 0.05);
}

export function trackKey(track, index) {
  return String(track?.id ?? track?.track_id ?? `track-${index}`);
}

export function isContentCompleted(track) {
  if (track?.completed === true) return true;
  if (String(track?.status ?? '').trim().toLowerCase() === 'completed') return true;
  const progress = Number(track?.progress);
  return Number.isFinite(progress) && progress >= 100;
}

export function isContentInProgress(track) {
  if (isContentCompleted(track)) return false;
  return String(track?.status ?? '').trim().toLowerCase() === 'in_progress';
}

/** Keep catalog order, with finished contents after the ones still to do. */
export function withCompletedLast(tracks) {
  const list = Array.isArray(tracks) ? tracks : [];
  const open = [];
  const done = [];
  list.forEach((item) => {
    if (isContentCompleted(item)) done.push(item);
    else open.push(item);
  });
  return open.concat(done);
}

export function ctaLabel(track) {
  if (track?.locked) return 'Locked';
  if (isContentCompleted(track)) return 'Review Quick Richuel';
  if (isContentInProgress(track) || Number(track?.completed_task_count) > 0) return 'Continue';
  return 'Start Quick Richuel';
}
